import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
} from "@angular/core";
import moment from "moment";
import { UI } from "../../../../services/ui.service";
import { SecEventsService } from "../sec-events.service";
import { Subscription } from "rxjs";
import { ConversionUtils } from "../../../../domain/conversion-utils";
import { RouteSecEventType } from "../../../../domain/route-sec-event-type";
import { Show } from "../../../../domain/show";

@Component({
  selector: "evrideo-calendar-expandable-autopilot-event",
  templateUrl: "./calendar-expandable-autopilot-event.component.html",
  styleUrls: ["./calendar-expandable-autopilot-event.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarExpandableAutopilotEventComponent implements OnInit {
  @Input() autopilotData;

  @Input() show: Show;

  @Input() formatTime: (time: moment.Moment) => string;
  @Input() formatDuration: (duration: moment.Duration) => string;
  @Input() toggleSecEvent: (show: Show, eventId: string) => void;

  properties;

  eventVisible = true;

  onEventToggleSubscription: Subscription;

  constructor(
    private ui: UI,
    private secEventsApi: SecEventsService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.properties = this.autopilotData.properties;

    this.onEventToggleSubscription = this.secEventsApi.onEventToggle.subscribe(
      (data) => {
        if (
          data.showId === this.show.id &&
          data.id === this.autopilotData.properties.instanceId &&
          data.offset === this.autopilotData.properties.offset
        ) {
          this.updateEventToggleUI();
        }
      },
    );
  }

  updateEventToggleUI() {
    this.autopilotData.properties.enabled =
      !this.autopilotData.properties.enabled;
    this.changeDetectorRef.detectChanges();
  }
}
